module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/id/3-c5fa4889822a696ad14bee6a395aab7d.jpg";